import React from 'react';

function PlainPage(props) {
	return <div className="p-44" dangerouslySetInnerHTML={{ __html: props.data.content }} />;
}

export default PlainPage;
